import React from "react";
import Catalogue from "../Catalogue";
import { Link, useParams } from "react-router-dom";
import axios from "axios";

const ProductCollection = () => {
  const [loading, setLoading] = React.useState(true);
  const [productCollection, setProductCollection] = React.useState({});
  const { collection } = useParams();
  // The clicked collection name from the URL is the source of truth for both
  // the heading and the product filter. getOne is only used to enrich the page
  // with a description / title image; a 404 there must NOT blank the filter
  // (doing so used to make the page show ALL products).
  const collectionName = decodeURIComponent(collection || "");

  const getProductCollection = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `/api/productCollection/getOne/${collection}`
      );

      setProductCollection(response.data.productCollection || {});
      setLoading(false);
    } catch (error) {
      console.log(error);
      // Lookup failed: keep going with the URL name so filtering still works.
      setProductCollection({});
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getProductCollection();
  }, [collection]);

  const titleText = (
    <div>
      <p>{productCollection.description}</p>
    </div>
  );

  return (
    <>
      {loading && <div>Loading...</div>}
      {!loading && (
        <div>
          <Catalogue
            key={collectionName}
            title={collectionName}
            titleText={titleText}
            titleImage={
              productCollection.image && productCollection.image.length > 0
                ? productCollection.image[0].url
                : ""
            }
            category={""}
            productCollection={collectionName}
          />
        </div>
      )}
    </>
  );
};

export default ProductCollection;
